import { Component, Input } from '@angular/core';

/** One item as it now stands in the catalogue. */
export interface CatalogueViewItem {
  name: string;
  partNumber?: string | null;
  makerPartNo?: string | null;
  supplierPartNo?: string | null;
  drawingNo?: string | null;
  positionNo?: string | null;
  partType?: string | null;
  sfiCode?: string | null;
  equipment?: string | null;
  equipmentName?: string | null;
  equipmentManufacturer?: string | null;
  equipmentModel?: string | null;
  equipmentSerialNo?: string | null;
  /** PENDING = waiting on admin, LIVE = on the platform, MASTER = unowned. */
  state: 'PENDING' | 'LIVE' | 'MASTER';
}

/**
 * What just landed in the catalogue, and where it stands.
 *
 * After an import the counts alone ("30 imported") do not answer the question
 * the user actually has: what came in, and can anyone see it yet? A supplier's
 * upload is invisible until an admin approves it; an admin's master upload is
 * live but owned by nobody until a supplier assigns it. Those are different
 * situations and the list says which is which, per item.
 */
@Component({
  selector: 'app-catalogue-view',
  templateUrl: './catalogue-view.component.html',
  styleUrls: ['./catalogue-view.component.css'],
})
export class CatalogueViewComponent {
  @Input() items: CatalogueViewItem[] = [];
  @Input() heading = 'In your catalogue';
  /** Machine these parts belong to, when they share one. */
  @Input() equipment = '';

  expanded = false;

  /** Show a handful by default; a 30-part import should not flood the page. */
  get visible(): CatalogueViewItem[] {
    return this.expanded ? this.items : this.items.slice(0, 6);
  }

  get pendingCount(): number {
    return this.items.filter((i) => i.state === 'PENDING').length;
  }
  get liveCount(): number {
    return this.items.filter((i) => i.state !== 'PENDING').length;
  }

  stateLabel(state: string): string {
    if (state === 'PENDING') return 'Awaiting approval';
    if (state === 'MASTER') return 'Live · master catalogue';
    return 'Live';
  }

  stateClass(state: string): string {
    if (state === 'PENDING') return 'cv-chip--pending';
    if (state === 'MASTER') return 'cv-chip--master';
    return 'cv-chip--live';
  }
}
